// src > UxGrid
import { ComponentType } from 'react'
import DataScale from '../ScaleData'
import { IBlockData } from '../BlockData'
import { IBlockType } from '../BlockType'
import { OverlayContentProps } from '../Overlay'

export const defaultProps = Object.freeze({
	autoActivate: false,
	multiTypeSelect: false,
	labelFrequency: 2,
	infiniteScroll: [false, false] // [x, y]
})

export enum QueryStatus {
	IDLE = 'idle',
	PROGRESS = 'progress'
}

export type UxGridState<BlockTypesType> = {
	scrollTop?: number
	columnNames: string[]
	scale: DataScale
	mouseDownIx: number | null
	mouseEnterIx: number | null
	colWidth: number
	details: IBlockData<BlockTypesType> | null
	[key: string]:
		| boolean
		| string[]
		| IBlockData<BlockTypesType>
		| IBlockData<BlockTypesType>[]
		| DataScale
		| number
		| undefined
		| null
}

export type BlockTypeSelectState = {
	selected: string[]
}

export type BlockTypeSelectProps<T> = {
	withBlockTypeManagement?: boolean
	blockTypes: IBlockType<T>[]
	AddBlockTypeComponent?: ComponentType
	removeBlockType?(resource: T): void
}

export type UxGridProps<BlockTypesType> = {
	queryStatus: QueryStatus
	columns: string[] | Function[]
	selectedTypes: IBlockType<BlockTypesType>[]
	blockTypes: IBlockType<BlockTypesType>[]
	scale: DataScale
	initialBlocks?: any[][]
	className?: string
	DetailsView: ComponentType<OverlayContentProps<BlockTypesType>>
	dataToBlock: (data: any) => IBlockData<BlockTypesType>
	blockToData: (block: IBlockData<BlockTypesType>) => any
	labelConversion: (ix: number) => string
	handleSave(rawBlocks: any[][]): Promise<void>
} & typeof defaultProps
